// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1Mky2","right":"styles_right__26ARt"};